<template>
    <div class="projects">
        <b-container fluid>
            <b-container :class="{'mapStyle-1' : switchView == 'map'}">
                <el-header height="80px" class="search">
                    <h2 class="title hidden-xs-only" v-if="region.name">
                        <span :class="`flag flag-icon flag-icon-${region.flag}`"></span>
                        {{region.name}}
                    </h2>
                    <a
                        :href="`/global-market-rankings/#${ranking.rank}`"
                        target="_blank"
                        class="city-scorebar hidden-md-and-down"
                        :class="{lessWidth: ranking.rank > 50}"
                    >
                        <div class="ranking" v-if="ranking.rank <= 50">
                            <div class="ranking-label">
                                <div class="ranking-name">{{$t("searchResultPage.scorebox.rank")}}</div>
                                <span class="tooltip_icon">
                                    <span
                                        class="tooltip-inner"
                                    >{{$t("searchResultPage.scorebox.rank_tooltip")}}</span>
                                </span>
                            </div>
                            <div class="ranking-score">{{ranking.rank}}</div>
                        </div>
                        <div class="ranking">
                            <div class="ranking-label">
                                <div class="ranking-name">{{$t("searchResultPage.scorebox.score")}}</div>
                                <span class="tooltip_icon">
                                    <span
                                        class="tooltip-inner"
                                    >{{$t("searchResultPage.scorebox.score_tooltip")}}</span>
                                </span>
                            </div>
                            <div class="ranking-score">{{ranking.score}}</div>
                        </div>
                        <div class="ranking">
                            <div class="ranking-label">
                                <div
                                    class="ranking-name"
                                >{{$t("searchResultPage.scorebox.median_price")}}({{currency}}/{{unit.toUpperCase()}})</div>
                            </div>
                            <div class="ranking-score">{{ranking.median_price_per_sqm}}</div>
                        </div>
                        <div class="ranking">
                            <div class="ranking-label">
                                <div
                                    class="ranking-name"
                                >{{$t("searchResultPage.scorebox.gross_yield")}}</div>
                            </div>
                            <div class="ranking-score">{{ranking.median_gross_yield}}%</div>
                        </div>
                    </a>
                    <div
                        class="dropdown_result hidden-xs-only"
                        @click="collapseCitySelection = !collapseCitySelection;"
                        :class="{'active': collapseCitySelection}"
                    >
                        <input
                            type="text"
                            :placeholder="$t('searchResultPage.placeholder.header_input')"
                            readonly="readonly"
                            :value="$t('searchResultPage.dropdown')"
                        />
                        <div
                            id="menu3"
                            class="hidden-sm-and-down dropdown-menu open"
                            style="left: unset; right: 0;transform: unset; "
                            aria-labelledby="drop6"
                            v-html="citySelection"
                            v-if="collapseCitySelection"
                            @click.prevent="goToCity"
                            v-click-outside="closeCitySelection"
                        ></div>
                        <!-- <el-collapse-item class="hidden-md-and-up" v-if="collapseCitySelection"> -->
                        <!-- <el-collapse v-model="activeName" accordion> -->
                        <!-- <el-collapse-item v-for="item in items" :key="item.id" :title=item :name="1">
                    {{ item }}
                        </el-collapse-item>-->
                        <!-- </el-collapse> -->
                        <!-- </div> -->
                    </div>
                    <el-select
                        class="hidden-sm-and-up"
                        v-model="region"
                        :placeholder="$t('searchResultPage.placeholder.header_input')"
                        :no-match-text="$t('searchResultPage.noResult')"
                        value-key="id"
                        @change="directOtherLink"
                    >
                        <!-- <el-option-group
                v-for="(group,index) in regionList"
                :key="index"
                        :label="'Top 10 region'">-->
                        <el-option
                            v-for="item in regionList"
                            :key="item.id"
                            :label="item.name"
                            :value="item"
                        ></el-option>
                        <!-- </el-option-group> -->
                    </el-select>
                </el-header>
            </b-container>
        </b-container>

        <b-container fluid class="filter">
            <b-container :class="{'mapStyle-1' : switchView == 'map'}">
                <el-main
                    v-click-outside="handleClose"
                    :class="{'mapStyle-2' : switchView == 'map'}"
                >
                    <div class="mobile-filter-group hidden-sm-and-up filter_box">
                        <el-button
                            plain
                            @click="isOpenFilterBox = !isOpenFilterBox"
                        >{{$t('searchResultPage.Filters')}}</el-button>
                        <button
                            class="top10"
                            @click="toggleActive('top10')"
                            :class="{ active: top10 }"
                        >{{$t("searchResultPage.top10")}}</button>

                        <div v-if="switchView == 'map'" class="controller-map">
                            <div class="filter-list">
                                <span class="heatmap-mode hidden-sm-and-down">Heatmap Mode</span>
                                <el-switch v-model="mapData.heatmapMode"></el-switch>
                            </div>

                            <div class="filter-list controller-list">
                                <button plain class="switch-view-btn" @click="changeView('list')"></button>
                            </div>
                        </div>
                    </div>

                    <div class="filter-list hidden-xs-only">
                        <el-button plain @click="toggle('showType')">
                            <span
                                v-if="assginValueToFilterBtn.project_type == 0"
                            >{{$t("searchResultPage.projectType.name")}}</span>
                            <span
                                v-if="assginValueToFilterBtn.project_type == 1"
                            >{{checkedTypes.toString()}}</span>
                            <span
                                v-if="assginValueToFilterBtn.project_type == 2"
                            >{{$t("searchResultPage.projectType.Multiple")}}</span>
                        </el-button>
                        <div class="filter-box" v-show="filterBtnList.showType">
                            <el-checkbox-group
                                v-model="checkedTypes"
                                @change="handleCheckedTypesChange"
                            >
                                <el-checkbox
                                    style="display: block"
                                    v-for="type in types"
                                    :label="type"
                                    :key="type"
                                >{{type}}</el-checkbox>
                            </el-checkbox-group>
                            <el-checkbox
                                :indeterminate="isIndeterminate"
                                v-model="checkAll"
                                @change="handleCheckAllChange"
                            >{{$t('searchResultPage.projectType.All')}}</el-checkbox>
                        </div>
                    </div>

                    <div class="filter-list hidden-xs-only">
                        <el-button plain @click="toggle('showPrice')">
                            <span
                                v-if="!assginValueToFilterBtn.price_area"
                            >{{$t("searchResultPage.avgPrice.name." + unit)}}</span>
                            <span
                                v-if="assginValueToFilterBtn.price_area"
                            >{{ currency }}{{ price_area[0] | NumFormat}} - {{ currency }}{{ price_area[1] | NumFormat}}</span>
                        </el-button>
                        <div class="filter-box filter-slider" v-show="filterBtnList.showPrice">
                            <div class="filter-block">
                                <span
                                    class="demonstration"
                                >{{ $t("searchResultPage.avgPrice.avgPrice", {unit_en: $t("searchResultPage.avgPrice.text." + unit), unit: unit, currency: currency }) }}{{price.price_area_avg | NumFormat}}</span>
                                <el-slider
                                    v-model="price_area"
                                    range
                                    :min="price.price_area_min"
                                    :max="price.price_area_max"
                                    :format-tooltip="tooltips"
                                    @change="assignVal('price_area')"
                                ></el-slider>
                                <span
                                    class="range"
                                >{{ currency }}{{price_area[0] | NumFormat }} - {{ currency }}{{ price_area[1] | NumFormat }}</span>
                                <div class="btnGroup">
                                    <el-button
                                        class="clearValue"
                                        type="text"
                                        @click="price_area = [price.price_area_min, price.price_area_max]; assginValueToFilterBtn.price_area = false"
                                    >{{$t("searchResultPage.avgPrice.clear")}}</el-button>
                                    <el-button
                                        class="applyVal"
                                        type="text"
                                        @click="applyFilters"
                                    >{{$t("searchResultPage.avgPrice.apply")}}</el-button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="filter-list hidden-xs-only">
                        <el-button plain @click="toggle('showStartPrice')">
                            <span
                                v-if="!assginValueToFilterBtn.price_starting"
                            >{{$t("searchResultPage.startingPrice.name")}}</span>
                            <span
                                v-if="assginValueToFilterBtn.price_starting"
                            >{{ currency }}{{ price_starting[0] | NumFormat}} - {{ currency }}{{ price_starting[1] | NumFormat}}</span>
                        </el-button>
                        <div class="filter-box filter-slider" v-show="filterBtnList.showStartPrice">
                            <div class="filter-block">
                                <span
                                    class="demonstration"
                                >{{$t("searchResultPage.startingPrice.avgPrice")}} {{ currency }}{{ price.price_starting_avg | NumFormat}}</span>
                                <el-slider
                                    v-model="price_starting"
                                    range
                                    :max="price.price_starting_max"
                                    :min="price.price_starting_min"
                                    :step="100"
                                    :format-tooltip="tooltips"
                                    @change="assignVal('price_starting')"
                                ></el-slider>
                                <span
                                    class="range"
                                >{{ currency }}{{ price_starting[0] | NumFormat}} - {{ currency }}{{ price_starting[1] | NumFormat}}</span>
                                <div class="btnGroup">
                                    <el-button
                                        class="clearValue"
                                        type="text"
                                        @click="price_starting = [price.price_starting_min, price.price_starting_max]; assginValueToFilterBtn.price_starting = false"
                                    >{{$t("searchResultPage.startingPrice.clear")}}</el-button>
                                    <el-button
                                        class="applyVal"
                                        type="text"
                                        @click="applyFilters"
                                    >{{$t("searchResultPage.startingPrice.apply")}}</el-button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <button
                        class="top10 hidden-xs-only"
                        @click="toggleActive('top10')"
                        :class="{ active: top10 }"
                    >{{$t("searchResultPage.top10")}}</button>

                    <div class="filter-list hidden-xs-only" @click="clearAllFilter">
                        <div
                            class="clearAll"
                            v-show="assginValueToFilterBtn.price_area || assginValueToFilterBtn.price_starting || assginValueToFilterBtn.project_type!=0 "
                        >{{$t('searchResultPage.clearAll')}}</div>
                    </div>

                    <div class="controller-list" v-if="switchView == 'list'">
                        <button
                            class="switch-view-btn-map"
                            :class="{lang: 'lang'}"
                            @click="changeView('map')"
                        ></button>
                    </div>

                    <div v-if="switchView == 'map'" class="controller-map hidden-xs-only">
                        <div class="filter-list">
                            <span
                                class="heatmap-mode hidden-sm-and-down"
                            >{{ $t("searchResultPage.heatmapMode") }}</span>
                            <el-switch v-model="mapData.heatmapMode"></el-switch>
                        </div>

                        <div class="filter-list controller-list">
                            <button plain class="switch-view-btn" @click="changeView('list')"></button>
                        </div>
                    </div>
                </el-main>
            </b-container>
        </b-container>

        <SearchResultList
            :projects="projects"
            :isOpenOverLayShadow="isOpenOverLayShadow"
            :count="count"
            :region="region"
            :isHideLoadMore="isHideLoadMore"
            @loadMoreData="loadMore"
            @view="changeView"
            @clearAll="clearAllFilter"
            v-if="switchView == 'list'"
        />

        <SearchResultMap
            :map-data="mapData"
            :region_name="region.name"
            :is-open-over-lay-shadow="isOpenOverLayShadow"
            :api-geo-region-id="apiGeoRegionId"
            :api-jenks="apiJenks"
            @view="changeView"
            @clearAll="clearAllFilter"
            v-if="switchView == 'map'"
        />

        <transition
            name="slide"
            enter-active-class="animated slideInUp"
            leave-active-class="animated slideOutDown"
        >
            <div v-show="isOpenFilterBox" class="mobile-filter-box hidden-sm-and-up">
                <div class="transition-box">
                    <el-header height="57px">
                        <div class="text-right">
                            <span class="icon-close" @click="isOpenFilterBox = false"></span>
                        </div>
                    </el-header>
                    <el-main>
                        <div class="mobile-filter">
                            <span class="mobile-name">
                                <span>{{$t("searchResultPage.projectType.name")}}</span>
                            </span>
                            <div class="filter-box">
                                <el-checkbox-group
                                    v-model="checkedTypes"
                                    @change="handleCheckedTypesChange"
                                >
                                    <el-checkbox
                                        v-for="type in types"
                                        :label="type"
                                        :key="type"
                                    >{{type}}</el-checkbox>
                                </el-checkbox-group>
                                <el-checkbox
                                    :indeterminate="isIndeterminate"
                                    v-model="checkAll"
                                    @change="handleCheckAllChange"
                                >{{$t("searchResultPage.projectType.All")}}</el-checkbox>
                            </div>
                        </div>

                        <div class="mobile-filter">
                            <span class="mobile-name">
                                <span
                                    v-if="!assginValueToFilterBtn.price_area"
                                >{{$t("searchResultPage.avgPrice.name." + unit)}}</span>
                                <span
                                    v-if="assginValueToFilterBtn.price_area"
                                >{{ currency }}{{ price_area[0] | NumFormat}} - {{ currency }}{{ price_area[1] | NumFormat}}</span>
                            </span>
                            <div class="filter-block">
                                <span
                                    class="demonstration"
                                >{{ $t("searchResultPage.avgPrice.avgPrice", {unit_en: $t("searchResultPage.avgPrice.text." + unit), unit: unit, currency: currency }) }}{{price.price_area_avg | NumFormat}}</span>
                                <el-slider
                                    v-model="price_area"
                                    range
                                    :min="price.price_area_min"
                                    :max="price.price_area_max"
                                    :step="100"
                                    :format-tooltip="tooltips"
                                ></el-slider>
                                <span
                                    class="range"
                                >{{ currency }}{{ price_area[0] | NumFormat}} - {{ currency }}{{ price_area[1] | NumFormat}}</span>
                            </div>
                        </div>

                        <div class="mobile-filter">
                            <span class="mobile-name">
                                <span
                                    v-if="!assginValueToFilterBtn.price_starting"
                                >{{$t("searchResultPage.startingPrice.name")}}</span>
                                <span
                                    v-if="assginValueToFilterBtn.price_starting"
                                >{{ currency }}{{ price_starting[0] | NumFormat}} - {{ currency }}{{ price_starting[1] | NumFormat}}</span>
                            </span>
                            <div class="filter-block">
                                <span
                                    class="demonstration"
                                >{{$t("searchResultPage.startingPrice.avgPrice")}} {{ currency }}{{ price.price_starting_avg | NumFormat}}</span>
                                <el-slider
                                    v-model="price_starting"
                                    range
                                    :max="price.price_starting_max"
                                    :min="price.price_starting_min"
                                    :step="100"
                                    :format-tooltip="tooltips"
                                ></el-slider>
                                <span
                                    class="range"
                                >{{ currency }}{{ price_starting[0] | NumFormat}} - {{ currency }}{{ price_starting[1] | NumFormat}}</span>
                            </div>
                        </div>
                    </el-main>
                    <el-footer height="70px">
                        <el-button
                            type="primary"
                            plain
                            class="submit"
                            @click="isOpenFilterBox = false; getProjects()"
                        >{{$t("searchResultPage.applyFilters")}}</el-button>
                    </el-footer>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
let loading;

import defaultImg from "../../../website_20/static/img/default-no-img.svg";
import SearchResultMap from "@/components/SearchResultMap";
import SearchResultList from "@/components/SearchResultList";

export default {
    data() {
        return {
            citySelection: document.querySelector("#my-menu .dropdown-menu")
                .innerHTML,
            ranking: undefined,
            regionList: [],
            switchView: "list",
            mapData: {
                result: [],
                count: 1,
                fitBounds: [],
                heatmapMode: true
            },
            region: {
                id: undefined,
                name: undefined,
                flag: undefined
            },
            projects: [],
            relativeProjects: [],
            filterBtnList: {
                showType: false,
                showPrice: false,
                showStartPrice: false
            },
            assginValueToFilterBtn: {
                project_type: 0,
                price_area: false,
                starting_price: false
            },
            isOpenOverLayShadow: false,
            isOpenFilterBox: false,
            isHideLoadMore: false,
            next_URL: "",
            price_area: [],
            price_starting: [],
            price: {
                price_area_min: 0,
                price_area_avg: 0,
                price_area_max: 0,
                price_starting_min: 0,
                price_starting_avg: 0,
                price_starting_max: 0
            },
            count: undefined,
            top10: false,
            checkAll: true,
            checkedTypes: [
                this.$t("searchResultPage.projectType.Apartment"),
                this.$t("searchResultPage.projectType.Villa"),
                this.$t("searchResultPage.projectType.Terrace")
            ],
            types: [
                this.$t("searchResultPage.projectType.Apartment"),
                this.$t("searchResultPage.projectType.Villa"),
                this.$t("searchResultPage.projectType.Terrace")
            ],
            isIndeterminate: false,
            collapseCitySelection: false
        };
    },

    beforeMount() {
        this.ranking = this.$root.cityRanking;
        this.mainMode = !("alt" in this.$router.currentRoute.query);
        this.switchView = this.mainMode ? "list" : "map";
        if (window.screen.width < 768) {
            this.switchView = this.mainMode ? "list" : "map";
        }
        this.unit = this.$root.unit.toLowerCase();
        this.currency = this.$root.currency;
        this.apiProject =
            this.switchView == "map"
                ? this.$root.apiMapProject
                : this.$root.apiProject;
        this.apiRegion = this.$root.apiRegion;
        this.apiGeoRegionId = this.$root.apiGeoRegionId;
        this.apiJenks = this.$root.apiJenks;
        this.getCurrRegion();
        this.getRegion();
        // this.hideChatMarker();
    },

    methods: {
        loading() {
            loading = this.$loading({
                lock: true,
                target: ".main-area",
                text: this.$t("searchResultPage.loading"),
                color: "#3b6bbf",
                background: "rgba(255, 255, 255, 0.8)"
            });
        },

        getValuesFromUrl() {
            // get values from URL
            let values = {
                region_id: this.region.id ? this.region.id : ""
            };

            if (this.$router.currentRoute.query.hasOwnProperty("region_id")) {
                let paramObj = this.$router.currentRoute.query;
                values = {
                    region_id: paramObj.region_id,
                    project_type: paramObj.project_type,
                    // price_area : paramObj.price_area,
                    // price_starting : paramObj.price_starting,
                    top_10: paramObj.top_10
                };
            }

            return values;
        },

        applyFilters() {
            this.isOpenOverLayShadow = false;
            this.handleClose();
            this.getProjects();
        },

        postResultLoad(isRelative, contactResult) {
            return response => {
                if (contactResult) {
                    this.projects = this.projects.concat(response.data.results);
                    this.mapData.result = this.mapData.result.concat(
                        response.data.results
                    );
                } else {
                    this.updateData(response.data);
                }

                if (response.data.results.length > 0) {
                    this.region.flag = response.data.results[0].country_code.toLowerCase();
                }

                if (response.data.count == 0 && !isRelative) {
                    this.getRelativeProject();
                }

                loading.close();

                this.next_URL = response.data.next;

                this.isHideLoadBtn();
            };
        },

        directOtherLink(e) {
            let param = { ...this.$router.currentRoute.query };
            param.region_id = e.id;
            this.$router.push({
                path: `/real-estate/${e.slug}/`,
                query: param
            });
            this.$router.go();
        },

        initParam() {
            this.loading();
            var lang = document.documentElement.lang.replace();

            let values = this.getValuesFromUrl();

            this.$http
                .get(this.apiProject, {
                    params: { ...values }
                })
                .then(response => {
                    this.postResultLoad()(response);

                    this.price_area = [
                        Math.floor(response.data.price_area_min),
                        Math.ceil(response.data.price_area_max)
                    ];
                    this.price_starting = [
                        Math.floor(response.data.price_starting_min),
                        Math.ceil(response.data.price_starting_max)
                    ];

                    if (values.hasOwnProperty("project_type")) {
                        // this.price_area = values.price_area.split(',');
                        // this.price_starting = values.price_starting.split(',');
                        this.top10 = values.top_10 != "0" ? true : false;
                        const staticObject = [
                            {
                                zh: "公寓",
                                en: "Condo / Apartment",
                                key: "APARTMENT"
                            },
                            {
                                zh: "独栋别墅",
                                en: "Single Family / Villa",
                                key: "VILLA"
                            },
                            {
                                zh: "联排别墅",
                                en: "Townhome / Terrace",
                                key: "TOWNHOME"
                            }
                        ];
                        let projectType = [];
                        if (!values.project_type) {
                            this.checkedTypes = [];
                            this.checkAll = false;
                            return;
                        }
                        let passProjectType = values.project_type.split(",");

                        for (let i = 0; i < staticObject.length; i++) {
                            passProjectType.forEach(it => {
                                if (it == staticObject[i].key) {
                                    if (
                                        this.$router.currentRoute.params.lang ==
                                        "zh"
                                    ) {
                                        projectType.push(staticObject[i].zh);
                                    } else {
                                        projectType.push(staticObject[i].en);
                                    }
                                }
                            });
                        }
                        this.checkedTypes = projectType;
                    }
                });
        },

        getProjects() {
            let param_type = "";
            if (this.checkedTypes) {
                // I have to create this data structure because of  el-check-group does not support object type;
                const staticObject = [
                    {
                        zh: "公寓",
                        en: "Condo / Apartment",
                        key: "APARTMENT"
                    },
                    {
                        zh: "独栋别墅",
                        en: "Single Family / Villa",
                        key: "VILLA"
                    },
                    {
                        zh: "联排别墅",
                        en: "Townhome / Terrace",
                        key: "TOWNHOME"
                    }
                ];
                for (const item in staticObject) {
                    let it = staticObject[item];
                    for (let i = 0; i < this.checkedTypes.length; i++) {
                        if (
                            it.zh == this.checkedTypes[i] ||
                            it.en == this.checkedTypes[i]
                        ) {
                            param_type += it.key + ",";
                        }
                    }
                }
            }

            let queryParams = {
                region_id: this.region.id ? this.region.id : 1202,
                project_type: param_type,
                top_10: this.top10 ? 1 : 0
            };

            this.$http
                .get(this.apiProject, {
                    params: {
                        ...queryParams,
                        price_area: `${this.price_area[0]},${
                            this.price_area[1]
                        }`,
                        price_starting: `${this.price_starting[0]},${
                            this.price_starting[1]
                        }`
                    }
                })
                .then(this.postResultLoad());

            // "map" in this.$router.currentRoute.query ||
            if (!this.mainMode) {
                queryParams = Object.assign(queryParams, { alt: null });
            }

            this.$router.replace({ query: { ...queryParams } });
        },

        isHideLoadBtn() {
            if (this.next_URL) {
                this.isHideLoadMore = false;
            } else {
                this.isHideLoadMore = true;
            }
        },

        changeView(data) {
            this.handleClose();

            this.mainMode = !this.mainMode;

            let newParam = Object.assign({}, this.$router.currentRoute.query);
            if (this.mainMode) {
                $("body").addClass("main");
                delete newParam.alt;
            } else {
                $("body").removeClass("main");
                newParam.alt = null;
            }
            this.$router.replace({ query: newParam });

            if (data == "map") {
                this.apiProject = this.$root.apiMapProject;
                this.getProjects();
            } else {
                this.apiProject = this.$root.apiProject;
                this.getProjects();
            }

            this.switchView = data;
            // this.hideChatMarker();
        },

        hideChatMarker() {
            if (this.switchView == "map") {
                document.querySelector(
                    "#hubspot-messages-iframe-container"
                ).style.display = "none !important";
            } else {
                document.querySelector(
                    "#hubspot-messages-iframe-container"
                ).style.display = "block";
            }
        },

        loadMore() {
            this.loading();

            this.$http
                .get(this.next_URL)
                .then(this.postResultLoad(false, true));
        },

        updateData(d) {
            this.price = {
                price_area_min: Math.floor(d.price_area_min),
                price_area_avg: Math.round(d.price_area_avg),
                price_area_max: Math.ceil(d.price_area_max),
                price_starting_min: Math.floor(d.price_starting_min),
                price_starting_avg: Math.round(d.price_starting_avg),
                price_starting_max: Math.ceil(d.price_starting_max)
            };
            this.projects = d.results;
            this.count = d.count;
            this.mapData.result = d.results;
            this.mapData.count = d.count;
        },

        toggleActive: function(key) {
            this[key] = !this[key];
            this.getProjects();
        },

        toggle: function(key) {
            this.isOpenOverLayShadow = true;

            for (let keys in this.filterBtnList) {
                if (keys != key) {
                    this.filterBtnList[keys] = false;
                } else {
                    this.filterBtnList[keys] = !this.filterBtnList[keys];
                }
            }
        },

        handleClose: function(e) {
            for (let key in this.filterBtnList) {
                this.filterBtnList[key] = false;
            }
        },

        closeCitySelection: function(e) {
            this.collapseCitySelection = false;
        },

        goToCity: function(e) {
            var href = $(e.target)
                .closest("[href]")
                .attr("href");

            href += href.indexOf("?") == -1 ? "?" : "";
            href += "&" + this.switchView;

            window.location.assign(href);
        },

        getRegion() {
            this.$http
                .get(this.apiRegion, {
                    params: {}
                })
                .then(response => {
                    this.regionList = response.data;
                    if (this.region.name === "") {
                        this.initParam();
                    } else {
                        this.regionList.filter(it => {
                            if (this.region.name == it.slug) {
                                this.region = it;
                                this.initParam();
                            }
                        });
                    }
                });
        },

        getCurrRegion() {
            // this.region.name = window.location.pathname ? window.location.pathname.slice(10, window.location.pathname.length).toLowerCase() : "";
            if (this.$router.currentRoute.params.regionName) {
                this.region.name = this.$router.currentRoute.params.regionName.toLowerCase();
            } else {
                this.region.name = "";
            }
        },

        getRelativeProject() {
            this.$http
                .get(this.apiProject, {
                    params: {
                        region_id: this.region.id ? this.region.id : 1202,
                        project_type: "APARTMENT,VILLA,TOWNHOME",
                        price_area: [this.price_area_min, this.price_area_max],
                        price_starting: [
                            this.price_starting_min,
                            this.price_starting_max
                        ]
                    }
                })
                .then(this.postResultLoad(false, true));
        },

        clearAllFilter() {
            this.checkedTypes = this.types;
            this.isIndeterminate = false;
            this.checkAll = true;
            this.price_area = [
                this.price.price_area_min,
                this.price.price_area_max
            ];
            this.price_starting = [
                this.price.price_starting_min,
                this.price.price_starting_max
            ];
            this.assginValueToFilterBtn = {
                project_type: 0,
                price_area: false,
                starting_price: false
            };
            this.top10 = false;

            // send quest again
            this.getProjects();
        },

        assignVal(key, value) {
            if (key == "project_type") {
                switch (value.length) {
                    case 0:
                        this.assginValueToFilterBtn.project_type = 0;
                        break;
                    case 1:
                        this.assginValueToFilterBtn.project_type = 1;
                        break;
                    default:
                        this.assginValueToFilterBtn.project_type = 2;
                        break;
                }
                return;
            }

            this.assginValueToFilterBtn[key] = true;
        },

        handleCheckAllChange(val) {
            this.checkedTypes = val ? this.types : [];
            this.isIndeterminate = false;

            this.assignVal("project_type", this.checkedTypes);
        },

        handleCheckedTypesChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.types.length;
            this.isIndeterminate =
                checkedCount > 0 && checkedCount < this.types.length;

            this.assignVal("project_type", value);
        },

        NumFormat: function(val) {
            if (!val) return "0";
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },

        tooltips: function(val) {
            if (!val) return "0";
            return (
                this.currency +
                val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            );
        },

        errorImg: function(param) {
            param.target.src = `${defaultImg}`;
        }
    },

    directives: {
        "click-outside": {
            bind: function(el, binding, vNode) {
                // Provided expression must evaluate to a function.
                if (typeof binding.value !== "function") {
                    const compName = vNode.context.name;
                    let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
                    if (compName) {
                        warn += `Found in component '${compName}'`;
                    }
                }
                // Define Handler and cache it on the element
                const bubble = binding.modifiers.bubble;
                const handler = e => {
                    if (bubble || (!el.contains(e.target) && el !== e.target)) {
                        binding.value(e);
                    }
                };
                el.__vueClickOutside__ = handler;

                // add Event Listeners
                document.addEventListener("click", handler);
            },

            unbind: function(el, binding) {
                // Remove Event Listeners
                document.removeEventListener("click", el.__vueClickOutside__);
                el.__vueClickOutside__ = null;
            }
        }
    },

    watch: {
        filterBtnList: {
            handler(newVal, oldVal) {
                if (Object.values(newVal).every(it => !it)) {
                    this.isOpenOverLayShadow = false;
                }
            },
            deep: true
        },

        isOpenOverLayShadow: {
            handler(newVal, oldVal) {
                if (!newVal) {
                    this.getProjects();
                }
            }
        },

        checkAll: {
            handler(newVal, oldVal) {
                if (newVal) {
                    this.assginValueToFilterBtn.project_type = 0;
                }
            }
        }
    },

    filters: {
        NumFormat: function(val) {
            if (!val) return "0";
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    },

    components: {
        SearchResultMap,
        SearchResultList
    }
};
</script>

<style scoped>
.mapStyle-1 {
    width: 100%;
    padding: 0;
}
.mapStyle-1 .el-header.search {
    display: flex;
    padding: 16px 23px;
}
.mapStyle-2 {
    padding: 12px 23px;
}
.container-fluid {
    padding: 0;
}
.controller-map {
    float: right;
    display: flex;
    align-items: center;
}

.controller-map .heatmap-mode {
    font-family: GothamMedium;
    margin-right: 10px;
    font-size: 14px;
    font-weight: 500;
    color: rgb(51, 51, 51);
}

.filter .el-main .controller-map .switch-view-btn {
    width: 200px;
    margin-left: 21px;
    border-radius: 4px;
    height: 48px;
    box-shadow: 0 1px 3px 0 rgb(155, 155, 155);
    border: 0;
    background: url("../../../website_20/static/img/show-list-btn@2x.png")
        no-repeat;
    background-size: cover;
}

html[lang="zh"] .filter .el-main .controller-map .switch-view-btn {
    background: url("../../../website_20/static/img/show-list-btn-cn@2x.png")
        no-repeat;
    background-size: cover;
}

.filter .controller-list .switch-view-btn-map,
.filter .controller-list .switch-view-btn {
    z-index: 2;
    width: 200px;
    height: 48px;
    padding: 0;
    margin-left: 37px;
    margin-top: -5px;
    box-shadow: 0 1px 3px 0 rgb(155, 155, 155);
    border: 0;
    border-radius: 6px;
    background: url("../../../website_20/static/img/show-map-btn@2x.png")
        no-repeat;
    background-size: cover;
}
.filter .controller-list .switch-view-btn-map:hover,
.filter .controller-list .switch-view-btn:hover {
    transition: transform 0.3s;
    transform: scale(1.03);
}

html[lang="zh"] .filter .controller-list .switch-view-btn-map,
.filter .controller-list .switch-view-btn {
    background: url("../../../website_20/static/img/map-btn-blue-cn@2x.png")
        no-repeat;
    background-size: cover;
}

.slide-enter-active {
    animation: all 0.3s linear;
}

.projects .search {
    text-align: left;
    position: relative;
}

.search .title {
    display: inline-flex;
    align-items: center;
    height: 50px;
    font-family: GothamBook;
    font-size: 22px;
    font-weight: bold;
    line-height: 50px;
    color: var(--brownish-grey);
}

.search .city-scorebar {
    margin-left: 14px;
    max-width: 478px;
    width: 100%;
    min-width: 380px;
    height: 50px;
    vertical-align: middle;
    display: inline-flex;
    justify-content: space-between;
    border-radius: 3px;
    background-color: rgba(242, 247, 255, 0.6);
    padding: 7px 20px;
    transition-duration: 0.3s;
    transition-property: transform;
}
.search .city-scorebar:hover {
    transform: scale(1.03);
}

.search .city-scorebar.lessWidth {
    width: auto;
}

.search .city-scorebar .ranking {
    position: relative;
}

.search .city-scorebar .ranking .ranking-label {
    position: relative;
    margin-bottom: 7px;
    height: 14px;
}

.search .city-scorebar .ranking .ranking-label .tooltip_icon {
    position: absolute;
    right: -18px;
    top: -1px;
    display: inline-block;
    cursor: pointer;
    width: 18px;
    height: 18px;
    background: url("../../../website_20/static/img/info.svg") no-repeat;
    background-size: cover;
}

.search
    .city-scorebar
    .ranking
    .ranking-label
    .tooltip_icon:hover
    .tooltip-inner {
    display: block;
}

.search .city-scorebar .ranking .ranking-label .tooltip_icon .tooltip-inner {
    display: none;
    position: absolute;
    transform: translate(-50%, -100%);
    padding: 12px;
    width: 200px;
    font-family: OpenSans;
    font-size: 13px;
    line-height: 1.38;
    text-align: center;
    color: var(--white);
    bottom: 23px;
    left: 4px;
    transform: translateX(-50%);
}

.search
    .city-scorebar
    .ranking
    .ranking-label
    .tooltip_icon
    .tooltip-inner:before {
    content: "";
    position: absolute;
    display: inline-block;
    width: 10px;
    height: 10px;
    border-left: 1px solid #000;
    border-top: 1px solid #000;
    transform: rotate(45deg);
    z-index: -1;
    background-color: #000;
    bottom: -5px;
    right: 50%;
    margin-right: -10px;
}

.search .city-scorebar .ranking:not(:last-child):after {
    content: "";
    position: absolute;
    right: -30px;
    top: 10px;
    display: inline-block;
    height: 20px;
    border-right: solid 1px #d8d8d8;
}

.search .city-scorebar .ranking .ranking-label .ranking-name {
    font-family: GothamMedium;
    font-size: 10px;
    line-height: 1.4;
    color: var(--brownish-grey);
}

.search .city-scorebar .ranking .ranking-score {
    line-height: normal;
    font-family: GothamMedium;
    font-size: 16px;
    color: var(--dark-indigo);
}

.search .dropdown_result {
    z-index: 100;
    position: absolute;
    display: block;
    width: 255px;
    height: 48px;
    line-height: 48px;
    top: 14px;
    right: 20px;
    border: 1px solid #d8d8d8;
    border-radius: 6px;
    color: #9b9b9b;
}

.search .dropdown_result:after {
    content: "";
    display: inline-block;
    width: 24px;
    height: 24px;
    position: absolute;
    right: 24px;
    top: 12px;
    background: url("../../../website_20/static/img/arrow-down.svg") no-repeat;
    background-position: 0 0;
    transition: all 0.3s;
    color: #666;
}

.search .dropdown_result.active:after {
    transform: rotate(0.5turn);
}

.search .dropdown_result input {
    cursor: pointer;
    padding: 0 50px 0 15px;
    outline: none;
    border: 0;
    font-family: GothamBook;
    color: #333;
    font-size: 16px;
    border-radius: 6px;
    width: 100%;
    height: 100%;
    box-shadow: 0 2px 10px 0 rgba(155, 155, 155, 0.5);
    color: #9b9b9b;
}

.search .dropdown_result input::placeholder {
    color: #9b9b9b;
}

.el-select {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%);
}

.filter {
    border-top: 1px solid #d8d8d8;
    border-bottom: 1px solid #d8d8d8;
}

.filter .el-main {
    overflow: visible;
    padding-top: 0.12rem;
    padding-bottom: 0.14rem;
}

.filter .el-main .mobile-filter-group .el-button {
    margin-right: 15px;
}

.filter .el-main .filter-list {
    display: inline-block;
    margin-right: 15px;
    position: relative;
}
.filter .el-main .filter-list:last-child {
    margin-top: 13px;
}

.filter .el-main .filter-list .clearAll {
    font-family: GothamBook;
    cursor: pointer;
    font-size: 14px;
    line-height: 2;
    letter-spacing: 0.4px;
    color: var(--windows-blue);
    margin-left: 15px;
}

.filter .controller-list {
    float: right;
    display: flex;
    align-items: center;
}

.filter .el-main .filter-list > .el-button,
.filter .el-main .mobile-filter-group > .el-button {
    width: 100%;
    padding: 11px 12px;
    font-size: 0.16rem;
    color: rgb(51, 51, 51);
    border: 1px solid #d8d8d8;
    height: 0.4rem;
}

.filter .el-main .mobile-filter-group > .el-button {
    display: inline-block;
    width: 0.75rem;
}

.filter .el-main >>> .el-button:hover,
.filter .el-main >>> .el-button.active {
    background-color: rgb(216, 216, 216);
}

.filter .el-main >>> .el-button.submit {
    margin-left: 0;
    width: auto;
    border: 1.9px solid #3b6bbf;
    background: #fff;
    color: #3b6bbf;
}

.filter .el-main >>> .el-button.submit:hover {
    background: #3b6bbf;
    color: #fff;
}

.filter .el-main .filter-list .filter-box {
    position: absolute;
    z-index: 5;
    top: 48px;
    left: 0;
    width: auto;
    padding: 30px 25px;
    border-radius: 4px;
    border: 1px solid #d8d8d8;
    box-shadow: 0 2px 10px 0 rgba(155, 155, 155, 0.5);
    background-color: #fff;
}

.filter .el-main .filter-list .filter-slider {
    width: 3.24rem;
    height: 1.64rem;
}

.filter .el-main .filter-list .filter-slider .filter-block {
    position: relative;
    height: 100%;
    width: 100%;
}

.projects .container .el-select >>> .el-input--suffix .el-input__suffix {
    right: 22px;
}

.projects
    .container
    .el-select
    >>> .el-input--suffix
    .el-input__suffix
    .el-input__icon {
    font-size: 14px;
    font-weight: bold;
    color: #666;
}

.projects .container .el-select >>> .el-input--suffix .el-input__inner {
    color: #9b9b9b;
    box-shadow: 0 1px 2px 0 rgba(155, 155, 155, 0.5);
}

.projects >>> .el-slider {
    padding: 0 8px;
}

.filter-block >>> .el-slider__bar {
    background-color: #3b6bbf;
}

.filter-block >>> .el-slider__button {
    border: 1px solid #d8d8d8;
}

.filter-block .text-right >>> .el-button {
    padding: 0;
}

.filter-box >>> .el-checkbox {
    margin-bottom: 22px;
}

.filter-box >>> .el-slider__runway,
.filter-block >>> .el-slider__runway {
    margin-top: 29px;
    margin-bottom: 10px;
}

.filter-box > .el-checkbox {
    margin-bottom: 0;
}

.filter-box >>> .el-checkbox + .el-checkbox {
    margin-left: 0;
}

.projects >>> .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
    height: 6px;
    top: 6px;
}

.projects >>> .el-checkbox__input {
    width: 20px;
    height: 20px;
    top: -2px;
}

.projects >>> .el-checkbox__input .el-checkbox__inner {
    width: 100%;
    height: 100%;
}

.projects >>> .el-checkbox__inner:hover {
    border-color: #d8d8d8;
}

.projects >>> .el-checkbox__inner::after {
    height: 9px;
    left: 6px;
    width: 3.6px;
    top: 2px;
    border-width: 3px;
}

.filter-box >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.projects >>> .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #3b6bbf;
    border-color: #3b6bbf;
}

.projects >>> .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #dcdfe6;
}

.filter-box >>> .el-checkbox__label,
.projects >>> .el-checkbox__input.is-checked + .el-checkbox__label {
    color: rgb(51, 51, 51);
    font-size: 0.16rem;
}

.filter-box >>> .demonstration {
    height: 0.15rem;
    font-size: 0.14rem;
    color: rgb(51, 51, 51);
}

.filter-box .range {
    font-size: 0.16rem;
    color: rgb(51, 51, 51);
}

.filter-box .btnGroup {
    display: flex;
    justify-content: space-between;
    height: 19px;
}

.filter .el-main .filter-list .filter-box .clearValue {
    font-family: OpenSans;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.4px;
    color: var(--brownish-grey);
}

.filter .el-main .filter-list .filter-box .applyVal {
    font-family: OpenSans;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.4px;
    color: var(--windows-blue);
}

.filter .el-main .filter-list .filter-box .clearValue:hover,
.filter .el-main .filter-list .filter-box .applyVal:hover {
    background-color: unset;
}

.top10 {
    border: 1px solid #d8d8d8;
    border-radius: 20px;
    font-size: 0.16rem;
    height: 40px;
    color: rgb(51, 51, 51);
    background-color: #fff;
    text-align: right;
    cursor: pointer;
    padding: 0 18px;
}

.top10:before {
    position: relative;
    left: -9px;
    content: "";
    display: inline-block;
    width: 20px;
    height: 19px;
    background: url("../../../website_20/static/img/stacked-group-4.svg")
        no-repeat;
    background-position: 0 0;
}

.top10.active {
    text-align: center;
    background-color: rgba(153, 178, 222, 0.3);
}

.top10.active:after {
    content: "";
    display: inline-block;
    position: relative;
    width: 12px;
    top: 0;
    right: -12px;
    height: 12px;
    background: url("../../../website_20/static/img/stacked-group-4.svg")
        no-repeat;
    background-position: -336px -6px;
}

.toolbar .map {
    margin-left: 37px;
    overflow: hidden;
    display: inline-block;
    border: 0;
    padding: 0;
    width: 2rem;
    height: 0.48rem;
}

.toolbar .map img {
    object-fit: cover;
    width: 100%;
    height: 100%;
}

.carousel >>> .el-carousel__container {
    z-index: 1;
}

.carousel >>> .el-carousel__item {
    /* border: 0.5px solid rgba(0,0,0,.05); */
    border-radius: 6px;
}

.load_more {
    font-family: GothamBook;
    font-size: 16px;
    letter-spacing: 0.4px;
    color: var(--white);
    width: 2rem;
    height: 0.4rem;
    padding: 0;
    text-align: center;
    color: #3b6bbf;
    border: 1.9px solid #3b6bbf;
}

.load_more i {
    display: inline-block;
    vertical-align: bottom;
    width: 12px;
    height: 15px;
    margin-right: 15px;
    overflow: hidden;
    background: url("../../../website_20/static/img/combined-shape-normal.svg")
        no-repeat;
    background-position: 0 0;
}

.load_more:hover {
    background-color: #3b6bbf;
    color: #fff;
}

.load_more:hover i {
    background: url("../../../website_20/static/img/combined-shape-hover.svg")
        no-repeat;
}

.projects >>> .el-input--suffix .el-input__inner,
.projects >>> .el-select .el-input.is-focus .el-input__inner,
.projects >>> .el-select .el-input__inner:focus {
    border: 1px solid #d8d8d8;
    border-radius: 4px;
}

@media (max-width: 992px) {
    .filter .el-main .filter-list {
        margin-right: 10px;
    }

    .filter .el-main .filter-list >>> .el-switch {
        height: 40px;
    }

    .filter .controller-list,
    .filter .controller-map .controller-list {
        z-index: 2;
        position: fixed;
        bottom: 25px;
        left: 50%;
        z-index: 4;
        transform: translate(-50%);
    }

    .filter .el-main .controller-map .switch-view-btn,
    .filter .controller-list .switch-view-btn-map,
    .filter .controller-list .switch-view-btn {
        margin-left: 0;
        margin-right: 0;
    }
}

/*Small devices (landscape phones, 576px and up)*/

@media (max-width: 577px) {
    .projects .container .el-select .search {
        width: 100%;
    }

    .projects .container .el-select {
        width: 100%;
    }

    .container,
    .container-fluid {
        padding-left: 18px;
        padding-right: 18px;
    }

    .container-fluid > .container {
        padding-left: 0;
        padding-right: 0;
    }

    .main-area {
        padding-left: 4px;
        padding-right: 4px;
    }

    .search {
        padding-left: 0;
        padding-right: 0;
    }

    .el-main {
        padding-left: 14px;
        padding-right: 14px;
    }

    .mobile-filter-box {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        height: 100%;
        width: 100%;
        z-index: 5;
        overflow-y: auto;
        background-color: #fff;
    }

    .projects >>> .transition-box.container-fluid.mobile-filter-box {
        padding-left: 26px;
        padding-right: 26px;
    }

    .mobile-filter-box .el-header {
        border-bottom: 1px solid rgb(216, 216, 216);
    }

    .mobile-filter-box .el-header {
        padding: 0 0.26rem;
        width: 100%;
    }

    .mobile-filter-box .el-header .icon-close {
        display: inline-block;
        height: 57px;
        width: 24px;
        background: url("../../../website_20/static/img/icon-close.svg")
            no-repeat center center;
    }

    .mobile-filter-box .el-main {
        padding: 0.2rem 0 0.3rem;
    }

    .mobile-filter-box .el-main {
        margin: 0 0.25rem;
        overflow-x: hidden;
        overflow-y: auto;
    }

    .mobile-filter-box .el-main .mobile-filter:not(:last-child) {
        border-bottom: 1px solid #d8d8d8;
    }

    .mobile-filter-box .el-main .mobile-filter {
        padding-bottom: 28px;
    }

    .mobile-filter-box .el-main .mobile-filter .mobile-name {
        font-family: GothamBold;
        font-size: 16px;
        display: inline-block;
        height: 0.54rem;
        line-height: 0.54rem;
        font-weight: bold;
        letter-spacing: 0.7px;
        color: #666;
        margin-bottom: 0.19rem;
    }

    .mobile-filter-box
        .el-main
        .mobile-filter
        >>> .el-checkbox
        .el-checkbox__label {
        height: 18px;
        font-size: 16px;
        color: rgb(51, 51, 51);
    }

    .mobile-filter-box .el-footer {
        border-top: 1px solid #d8d8d8;
        padding: 15px 25px;
        position: fixed;
        z-index: 1002;
        width: 100%;
        bottom: 0;
        background: #fff;
    }

    .mobile-filter-box .el-footer >>> .el-button {
        width: 100%;
        background-color: #3b6bbf;
        color: #fff;
    }

    .mobile-filter-box .filter-box >>> label.el-checkbox {
        display: block;
        height: 0.2rem;
    }

    .mobile-filter-box .filter-box >>> .el-checkbox__input {
        float: right;
        margin-right: 2px;
        top: 0;
    }

    .mobile-filter-box .filter-box >>> label.el-checkbox .el-checkbox__label {
        padding-left: 0;
    }
}

/*Medium devices (tablets, 768px and up)*/

@media (min-width: 768px) {
    .name {
        margin-right: 70px;
    }
    .filter .el-main .filter-list:last-child {
        margin-top: 0;
    }
}

/*Large devices (desktops, 992px and up)*/

@media (min-width: 992px) {
}

/*Extra large devices (large desktops, 1200px and up)*/

@media (min-width: 1200px) {
}

.flag {
    display: inline-block;
    width: 28px;
    height: 20px;
    margin-right: 15px;
    border-radius: 3px;
    border: 0.51px solid #eee;
    flex: 0 0 28px;
    vertical-align: baseline;
    background-size: cover;
    border: solid 0.5px rgb(216, 216, 216);
    box-shadow: 0 1px 1px 0 rgba(155, 155, 155, 0.3);
}
</style>



// WEBPACK FOOTER //
// src/components/SearchResult.vue